(function () {
  if (window.__mpnAssist) return; window.__mpnAssist = true;
  var C = window.__mpnAssistCfg || {};
  var LANG = C.lang, RW = C.rw, QL = C.ql, QR = C.qr;

  /* Vocabulaire client -> mot du catalogue. Ecrire sans accent ni majuscule (comparaison souple). */
  var SYN = {
    fr: [
      ['dalle', 'dallage'], ['dalles', 'dallage'],
      ['carrelage pierre', 'dallage pierre'], ['carrelage en pierre', 'dallage pierre'], ['carrelages pierre', 'dallage pierre'],
      ['bord piscine', 'margelle'], ['bords piscine', 'margelle'], ['bord de piscine', 'margelle'], ['bords de piscine', 'margelle'],
      ['contour piscine', 'margelle'], ['contour de piscine', 'margelle'], ['tour de piscine', 'margelle'],
      ['pierre mur', 'parement'], ['pierres mur', 'parement'], ['pierre murale', 'parement'], ['pierres murales', 'parement'],
      ['travertin beige', 'travertin'], ['travertins beiges', 'travertin'], ['travertin beiges', 'travertin'],
      ['opus romain', 'opus 4 formats'], ['opus 4', 'opus 4 formats'], ['opus iv', 'opus 4 formats'], ['opus quatre', 'opus 4 formats']
    ],
    en: [
      ['slab', 'paving'], ['slabs', 'paving'], ['stone tile', 'stone paving'], ['stone tiles', 'stone paving'],
      ['pool edge', 'pool coping'], ['pool edges', 'pool coping'], ['pool edging', 'pool coping'],
      ['pool surround', 'pool coping'], ['pool surrounds', 'pool coping'], ['pool border', 'pool coping'],
      ['wall stone', 'cladding'], ['wall stones', 'cladding'], ['wall cladding', 'cladding'], ['stone wall cladding', 'cladding'],
      ['beige travertine', 'travertine'], ['travertine beige', 'travertine'],
      ['roman opus', 'opus 4 formats'], ['opus roman', 'opus 4 formats'], ['opus 4', 'opus 4 formats'], ['opus iv', 'opus 4 formats'],
      ['french pattern', 'opus 4 formats']
    ],
    de: [
      ['beckenrand', 'poolrand'], ['beckenrandstein', 'poolrand'], ['beckenrandsteine', 'poolrand'], ['schwimmbadrand', 'poolrand'],
      ['pool rand', 'poolrand'], ['poolrandsteine', 'poolrand'],
      ['wandstein', 'verblender'], ['wandsteine', 'verblender'], ['steinwand', 'verblender'], ['natursteinwand', 'verblender'],
      ['wandverkleidung', 'verblender'], ['steinverkleidung', 'verblender'], ['verblendstein', 'verblender'], ['verblendsteine', 'verblender'],
      ['travertin beige', 'travertin'], ['beige travertin', 'travertin'], ['beiger travertin', 'travertin'],
      ['opus 4', 'opus 4 formate'], ['opus iv', 'opus 4 formate'], ['romischer verband', 'opus 4 formate']
    ]
  };

  function norm(s) {
    s = String(s || '').toLowerCase();
    if (s.normalize) s = s.normalize('NFD').replace(/[̀-ͯ]/g, '');
    return s.replace(/ß/g, 'ss').replace(/[^a-z0-9]+/g, ' ').trim();
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  var RULES = (SYN[LANG] || SYN.fr).map(function (r) { return { w: norm(r[0]).split(' '), to: r[1] }; })
    .sort(function (a, b) { return b.w.length - a.w.length; });

  /* Remplace les expressions connues ; renvoie la recherche telle quelle si rien ne correspond */
  function rewrite(q) {
    var raw = String(q || '').trim();
    if (!raw) return q;
    var rawT = raw.split(/\s+/), t = rawT.map(norm);
    var out = [], hit = false, i = 0;
    while (i < t.length) {
      var m = null;
      for (var k = 0; k < RULES.length && !m; k++) {
        var w = RULES[k].w, n = w.length, ok = i + n <= t.length;
        for (var j = 0; ok && j < n; j++) {
          var a = t[i + j], b = w[j];
          if (a === b) continue;
          /* dernier mot encore en cours de frappe (3 lettres au moins) dans une expression de 2 mots ou plus */
          if (n > 1 && j === n - 1 && i + j === t.length - 1 && a.length >= 3 && b.indexOf(a) === 0) continue;
          ok = false;
        }
        if (ok) m = RULES[k];
      }
      if (m) { out.push(m.to); i += m.w.length; hit = true; } else { out.push(rawT[i]); i++; }
    }
    if (!hit) return q;
    var res = [];
    out.join(' ').split(' ').forEach(function (x) { if (!res.length || norm(res[res.length - 1]) !== norm(x)) res.push(x); });
    return res.join(' ');
  }
  window.mpnSearchRewrite = rewrite;

  /* Touche Entree / loupe dans la recherche plein ecran : on cherche le mot du catalogue */
  document.addEventListener('submit', function (e) {
    if (e.defaultPrevented) return;
    var f = e.target;
    if (!f || !f.classList || !f.classList.contains('mpn-so__form')) return;
    var inp = f.querySelector('input[name="q"]');
    if (!inp) return;
    var q = inp.value.trim(), rq = rewrite(q);
    if (!q || rq === q) return;
    var d = window.mpnDirectUrl && window.mpnDirectUrl(rq);
    if (d) { e.preventDefault(); location.href = d; return; }
    inp.value = rq;
  });

  /* Resultats en direct : synonymes, correction des fautes, pages, memoire des reponses */
  var nativeFetch = window.fetch;
  if (!nativeFetch || typeof Response === 'undefined' || typeof URL === 'undefined') return;
  var cache = {}, keys = [];
  function totalOf(t) { var m = /data-total="(\d+)"/.exec(t || ''); return m ? +m[1] : -1; }
  function get(u, init) {
    if (Object.prototype.hasOwnProperty.call(cache, u)) return Promise.resolve(cache[u]);
    return nativeFetch.call(window, u, init)
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (t) {
        if (!Object.prototype.hasOwnProperty.call(cache, u)) { keys.push(u); if (keys.length > 40) delete cache[keys.shift()]; }
        cache[u] = t;
        return t;
      });
  }
  function note(t, shown) {
    var p = '<p class="mpn-so__rw">' + esc(RW) + ' ' + esc(QL) + esc(shown) + esc(QR) + '</p>';
    return t.replace(/(<div class="mpn-so-res"[^>]*>)/, '$1' + p);
  }
  window.fetch = function (input, init) {
    if (typeof input !== 'string' || input.indexOf('section_id=mpn-predictive') < 0 || input.indexOf('search/suggest') < 0) {
      return nativeFetch.apply(this, arguments);
    }
    var url;
    try { url = new URL(input, location.href); } catch (e) { return nativeFetch.apply(this, arguments); }
    var q = url.searchParams.get('q') || '';
    var types = url.searchParams.get('resources[type]');
    if (types && types.split(',').indexOf('page') < 0) url.searchParams.set('resources[type]', types + ',page');
    var sq = rewrite(q);
    var mk = function (qq) { var x = new URL(url.href); x.searchParams.set('q', qq); return x.href; };
    return get(mk(sq), init).then(function (t) {
      if (totalOf(t) === 0 && window.mpnDidYouMean) {
        var fix = window.mpnDidYouMean(q);
        var fq = fix ? rewrite(fix) : '';
        if (fq && norm(fq) !== norm(sq)) {
          return get(mk(fq), init).then(function (t2) { return totalOf(t2) > 0 ? note(t2, fq) : t; }, function (err) {
            if (err && err.name === 'AbortError') throw err;
            return t;
          });
        }
      }
      return sq !== q ? note(t, sq) : t;
    }).then(function (t) {
      return new Response(t, { status: 200, headers: { 'Content-Type': 'text/html; charset=utf-8' } });
    });
  };
})();
